import React from 'react'
import image2 from "../img/KindBaum.JPG"

const Slide2 = () => {
    return (
        <div className="">
            <div className="container container2">
                <div class="head"></div>
                <div className="text">
                    Der aktuelle Report des Weltklimarats alarmiert und fordert:
                    Es muss dringend gehandelt werden! Das braucht Mut und Kompetenz,
                    Menschlichkeit und soziale Unterstützung.
                </div>
                <div className="image image2">
                    <img src={image2} alt=""></img>
                </div>
                <div className="text">
                    <span>Darum geht es bei den anstehenden Wahlen am 26.
                    September: Respekt vor der Natur und Ehrfurcht vor dem Leben,
                    damit die Menschen bei uns und überall auf dem Planeten in Zukunft gut,
                    sicher und gesund leben können.  </span>
                    Denn, wie schon Albert Einstein sagte,
                    wir Menschen sind zwar Teil der Natur,
                    diese gehört uns aber nicht.
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide2;